/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {ASSET_ERROR} from '../../common/constants/resource-constants';
import {AdnHttpProgressCallback} from '../../../components/util/adn-http.service';
import {createAdnUploadFormData} from '../../../components/util/adn-http.service';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class ReferenceDataApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  upload(data: any, uploadType = 'categories', onProgress?: AdnHttpProgressCallback): Promise<any> {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    return firstValueFrom(this.client.upload({
      method: 'POST',
      url: this.apiConfig.getVersionedUri([uploadType, 'upload']),
      body: createAdnUploadFormData(data)
    }, onProgress));
  }
}
